// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3kBot","actionsCol":"EnrolledClinics_actionsCol__1AAfo"};